/**
 * 📦 PROMOTION PAYLOAD DTO
 * Fix: Removed all internal 'metadata' naming to prevent property shadowing 
 * in the shared storageService.js.
 */
export class PromotionPayload {
    constructor(siteKey, batchId, fileName, bucket = "esg-staging-clean") {
        this.siteKey = siteKey;
        this.batchId = batchId;
        this.fileNames = [fileName];
        this.targetBucket = bucket;
        this.targetRoot = "taxonomy/registry/integrated";
        this.S3CorsValue = "esg"; 

        this.labels = {}; // 🎯 RENAMED from 'metadata' to avoid collisions
        this.providedHash = "";
        this.timestamp = String(Math.floor(Date.now() / 1000));
        this.origin = window.location.origin;
    }

    addMetadata(key, value) {
        const sanitizedKey = key.toLowerCase().replace(/\s+/g, '-');
        this.labels[sanitizedKey] = String(value);
        return this;
    }

    setHash(hash) {
        this.providedHash = hash;
        return this;
    }

    toJSON() {
        return {
            siteKey: this.siteKey,
            batchId: this.batchId,
            fileNames: this.fileNames,
            targetBucket: this.targetBucket,
            targetRoot: this.targetRoot,
            S3CorsValue: this.S3CorsValue,
            providedHash: this.providedHash,
            timestamp: this.timestamp,
            origin: this.origin,
            
            // 🎯 THE FIX: No key named 'metadata' is exported.
            // Only the flat labels are spread into the root.
            ...this.labels 
        };
    }
}